<template>
    <header id="header" :class="{ 'scroll': small }">
        <nav :class="['navbar navbar-expand-lg fixed-top bg-white', { 'scroll': small }]">
            <div class="container">
                <router-link :to="{ name: 'Index'}" class="navbar-brand brand">
                    VEILIGHEIDS<span class="primary">TEAM</span>.NL
                    <p class="text-muted" v-show="!small">Meer dan een veilig gevoel</p>
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                            <a class="nav-link" href="https://wa.me/31640000933" target="_blank">
                                <font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon>&nbsp;06-40000933
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="mailto:info@veiligheidsteam.nl"><font-awesome-icon icon="envelope"></font-awesome-icon>&nbsp;info@veiligheidsteam.nl</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'the-header',
    data() {
        return {
            small: false
        }
    },
    mounted() {
        let self = this;
        window.addEventListener('scroll', (ev) => {
            if(ev.currentTarget.scrollY > 71 && !self.small)
            {
                self.small = true;
            } else if(ev.currentTarget.scrollY <= 71 && self.small) {
                self.small = false;
            }
        });
    }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles.scss";

header {
    margin-bottom: 71px;
    transition: margin-bottom .2s ease-in;
    -moz-transition: margin-bottom .2s ease-in;
    -webkit-transition: margin-bottom .2s ease-in;
}
header.scroll {
    margin-bottom: 50px;
}

.bg-white {
    background-color: #ffffff !important;
}
.navbar {
    border-bottom: 1px solid $darkColor;
    max-height: 71px;
    transition: max-height .2s ease-in;
    -moz-transition: max-height .2s ease-in;
    -webkit-transition: max-height .2s ease-in;

    
}

.navbar.scroll {
    max-height: 50px
}

.nav-link {
    color: $primaryColor;
}
</style>